module.exports = __webpack_public_path__ + "media/images/icon-search-clear-e8f1f010e58c854c979e84e40ed67c4c.svg";